import { types } from '../types/types';

const initialState = {
    categoryToggle: 'list',
    adminUserDialog: false,
    adminUserModal: {
        status: false,
        action: 'add'
    },
    formsModal: {
        open: false,
        action: 'add'
    },
    commentModal: {
        open: false,
        action: 'add',
        loading: false
    },
    loginModal: false,
    shopSnackbar: {
        status: false, // mostrar/ocultar snackbar
        origin_page: '', // tipo de error en petición
        err_msg: '', // mensaje de error para snackbar
    },
    loading2: false,
    user: {
        code_sent: false
    },
    user_account: {
        userOrdersTab: '1'
    },
    loading: { // ¿carga inicial de datos finalizada?
        shop_products: true,
        shopping_cart: true
    },
    cart: {
        action: false,
        messages: []
    }
};

export const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.ui_categoryToggle:
            return {
                ...state,
                categoryToggle: action.payload
            };
        case types.ui_adminUserModal:
            return {
                ...state,
                adminUserModal: action.payload
            };
        case types.ui_adminUserDialog:
            return {
                ...state,
                adminUserDialog: action.payload
            };
        case types.ui_formsModal:
            return {
                ...state,
                formsModal: action.payload
            };
        case types.ui_commentLoading:
            return {
                ...state,
                commentModal: {
                    ...state.commentModal,
                    ...action.payload
                }
            };
        case types.ui_commentModal:
            return {
                ...state,
                commentModal: action.payload
            };
        case types.ui_loginModal:
            return {
                ...state,
                loginModal: action.payload
            };
        case types.ui_shopSnackbar:
            return {
                ...state,
                shopSnackbar: action.payload
            };
        case types.uiLoading2:
            return {
                ...state,
                loading2: action.payload
            };
        case types.uiShopProductData:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    ...action.payload
                }
            };
        case types.uiLoginCodeModal:
            return {
                ...state,
                user: {
                    ...state.user,
                    code_sent: action.payload
                }
            };
        case types.userOrdersTab:
            return {
                ...state,
                user_account: {
                    ...state.user_account,
                    userOrdersTab: action.payload
                }
            };
        case types.uiShopProductModal:
            return {
                ...state,
                cart: {
                    ...state.cart,
                    ...action.payload
                }
            };
        default:
            return state;
    };
};